var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-scroll',{ref:"scrollComponent",class:['main-scroll', _vm.isMain ? 'isMainScroll' : ''],attrs:{"ops":_vm.ops},on:{"handle-scroll":_vm.handleScroll,"handle-resize":_vm.handleResize},nativeOn:{"wheel":function($event){return _vm.onMouseWheel.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }